import { deviceType } from "../modules/enums";
import { cdnUrl, parseSizes } from "../modules/utilities";
import { AdUnit, BidParamsUserSettingsData, MediaTypes } from "../types/prebid";
import { Size, SizeConfig, SlotKeyItterable, SlotSizeConfig } from "../types/publisher";

export default abstract class BaseBidder {
	protected slot: Slot;
	protected device: deviceType;
	protected bidderConfig: any;

	constructor(slot: Slot, device: deviceType, bidderConfig: any) {
		this.slot = slot;
		this.device = device;
		this.bidderConfig = bidderConfig ? bidderConfig : null;
	}

	protected abstract adUnitConfig: AdUnit;

	public getAdUnit(): AdUnit {
		let config = this.adUnitConfig;
		
		if (config.code) {
			config.ortb2Imp = {
				ext: {
					gpid: config.code,
					data: {
						pbadslot: config.code
					}
				}
			};
		}
		
		return config;
	}

	protected additionalSlotSizes: SlotSizeConfig = {};

	protected removeSlotSizes: Size[]  = [
		['fluid'],
	
		[300,260],
		[320,500],
	
		[510,510],
		[520,520],
		[530,530],
	
		[970,460],
		[970,500],
		[970,600],
	];

	protected getAdUnitSizes(): Size[] {
		const additionalSlotSizesConfig = this.additionalSlotSizes[this.slot.slotKey] ?? [];
		const additionalSlotSizes = parseSizes(additionalSlotSizesConfig, this.device) ?? [];
	
		const filteredSlotSizes = this.slot.sizes.filter(size => !this.removeSlotSizes.map(s => s.toString()).includes(size.toString()));

		return [...filteredSlotSizes, ...additionalSlotSizes];
	}

	protected get mediaTypeOutstreamSettings() {
		let mediaTypeVideoOutstreamSettings: MediaTypes["video"]  = {
			context: "outstream",
			playerSize: [[640, 360]]
		}

		if(this.slot.publisher.config.useCustomOutstreamRenderer) {
			let conf  = this.slot.publisher.config
			mediaTypeVideoOutstreamSettings =  {
				...mediaTypeVideoOutstreamSettings,
				...{
					renderer: {
						url: cdnUrl() + "/Outstream/js/outstream" + (this.slot.publisher.config.useCustomOutstreamRenderer == 'test' ? "-test" : "") + ".js",
						render: function (bid: any) { 
							let options:object|null = null

							if (bid && bid.bidder && conf.outstreamSettings) {
								let baseOutstreamSettings:object = conf.outstreamSettings.base ?? {};

								let bidderOutstreamSettings:object = conf.outstreamSettings.bidders && conf.outstreamSettings.bidders[bid.bidder] ? conf.outstreamSettings.bidders[bid.bidder] : {};

								options = Object.assign({},baseOutstreamSettings,bidderOutstreamSettings)

							}

							if (typeof window.initOutstream === "function") { 
								window.initOutstream(bid, options);
							}
						}
					}
				}
			}
		}
		

		return {
			video: mediaTypeVideoOutstreamSettings
		};
	}

	protected get bidParamsUserSettings(): {data: BidParamsUserSettingsData[]} {
		return {
			data: [
				{
					id: 'domein',
					name: 'domein',
					segment: [
						{
							id: 'domein',
							name: 'domein',
							get value() {
								let hostNameValue = location.hostname.replace(/^www\./,'').replace(/\./g,'_');
								hostNameValue = hostNameValue.charAt(0).toUpperCase() + hostNameValue.slice(1);
								return 'adf_'+hostNameValue;
							}
						}
					]
				}, {
					id: 'ang_cntp',
					name: 'ang_cntp',
					segment: [
						{
							id: 'ang_cntp',
							name: 'ang_cntp',
							value: 'Adfactor'
						}
					]
				}, {
					id: 'pos',
					name: 'pos',
					segment: [
						{
							id: 'pos',
							name: 'pos',
							value: this.slot.id
						}
					]
				},
				...this.getAdditionalBidParamsUserSettingsData()
			]
		}
	}

	protected getAdditionalBidParamsUserSettingsData(): BidParamsUserSettingsData[] {
		return [];
	}
}
